import type {ReactAction} from '@netx/core/bootstrap';
import {faCalendarTimes} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartExpiration} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Unset cart asset expiration
 * @param params
 * @returns Action
 */
export const cartActionManageExpirationUnset = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-expiration-unset',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.MANAGE_EXPIRATION_UNSET),
	enableTest: canManageCurrentCartExpiration,
	icon: faCalendarTimes,
	get label() {
		return CART_CURRENT_ACTION_LABELS.MANAGE_EXPIRATION_UNSET;
	},
	...params,
});

export default cartActionManageExpirationUnset;
